<script setup lang="ts">
import type { NovaSearchResultItemHashtagProps } from './NovaSearchResultItemHashtag.types'
import { ROUTES } from '@configs'

const props = defineProps<NovaSearchResultItemHashtagProps>()

const { gtEvent } = useGoogleTag()
const { t } = useI18n()

const handleOnGoHashtag = () => {
  // postStore.updateHashtagControl(props.source)
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '해시 태그',
    eventLabel: t('viewRelatedPosts'),
    eventSlot: '검색 결과 > 해시태그',
    eventI18nAddr: useKoreanTranslation('viewRelatedPosts'),
    eventComponent: 'Button',
  })
  useNavigations({ url: ROUTES.HASHTAG.path, query: { ...props.source } })
  // router.push({
  //   path: locale.value === 'ko' ? '/hashtag' : `/${locale.value}/hashtag`,
  //   query: postStore.hashtagControl.hashtag,
  // })
}
</script>

<template>
  <button
    type="button"
    class="search-result-item-hashtag"
    @click="handleOnGoHashtag"
  >
    <span class="hashtag"># {{ source.hashtagNm }}</span>

    <span class="indicator">
      <span class="label">{{ $t('viewRelatedPosts') }}</span>
      <NovaIcon
        :icon="{ type: 'outline', name: 'chev-compact-right' }"
        class="chev"
      />
    </span>
  </button>
</template>

<style lang="scss" scoped>
.search-result-item-hashtag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  padding: 20px 16px 20px 20px;
  background-color: $color-bg-3;
  border-radius: $radius-10;
  > .hashtag {
    flex-grow: 1;
    @include text-style($text-body-14-regular);
    @include ellipsis(1);
    line-height: 20px;
    text-align: left;
    letter-spacing: 0;
    color: $color-text-2;
  }

  > .indicator {
    display: flex;
    align-items: center;
    gap: 6px;

    > .label {
      @include text-style($text-body-12-regular);
      color: $color-text-3;
    }

    > .chev {
      flex-shrink: 0;
      color: $color-text-3;
    }
  }

  @include mobile {
    padding: 20px 5px 20px 10px;

    > .hashtag {
      flex-grow: 1;
      @include text-style($text-body-14-regular);
      @include ellipsis(1);
      line-height: 20px;
      text-align: left;
      letter-spacing: 0;
      color: $color-text-2;
    }
  }
}
</style>
